import React, { useEffect, useState } from "react";
import server from "../../Config";
import Select from 'react-select';
import { change_provider, clean_provider } from '../../redux/Appslice';
import { useDispatch } from 'react-redux';

const Provider = ({defaultValue}) => {

    const [taxonomies, setTaxonomies] = useState([{}]);
    const [select, setSelect] = useState(defaultValue);

    const dispatch = useDispatch();

    var con = 0;

    useEffect(() => {
        setSelect(defaultValue);
        con++;

        if(con === 1){
        const token = sessionStorage.getItem("token");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
    
        const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };
    
        fetch(server+"/api/taxonomy?taxonomy=provider", requestOptions)
        .then(response => response.json())
        .then(result => {
            const options = [];
            result.map(data => {
                options.push({ value: data.id, label: data.name });
            });
        
            setTaxonomies(options); 
        })
        .catch(error => console.log('error', error));
    }

    },[defaultValue]);

    const handleSelect = (data) => {
        setSelect(data);
        dispatch(clean_provider());
    }

    useEffect(()=>{
        dispatch(clean_provider());
        dispatch(change_provider(select));
    },[select]);

    return(
        <Select
        isMulti
        name="provider"
        options={taxonomies}
        className="basic-multi-select"
        classNamePrefix="select"
        value={select}
        onChange={handleSelect}
        placeholder="Select Provider"
      />
    )
}

export default Provider;